import { startMixpanelRecording } from "common/utils/mixpanel/tracker";

const HOTJAR_PINNING_EVENT = "design_lab_pinning_mode_entered";

let recordingStarted = false;

type StartPinSessionRecordingParams = {
  enabled: boolean;
};

export function startPinSessionRecording({ enabled }: StartPinSessionRecordingParams): boolean {
  if (!enabled || recordingStarted) return false;

  recordingStarted = true;

  startMixpanelRecording(100);

  const hotjar = (window as Window & { hj?: (...args: unknown[]) => void }).hj;
  if (typeof hotjar === "function") {
    hotjar("event", HOTJAR_PINNING_EVENT);
  }

  // eslint-disable-next-line no-console
  console.log("Hotjar pin session recording started");
  return true;
}
